import {
  Box,
  Button,
  Flex,
  FormControl,
  Input as ChakraInput,
  FormLabel,
} from "@chakra-ui/react";
import AsyncSelect from "react-select/async";
import { api } from "../../libs/axios";
import { Controller, useFormContext } from "react-hook-form";
import { optionsSelectStyles } from "../../styles/select";
import { useEffect } from "react";
import { diaDaSemana } from "../../utils/datetime";
import { queryClient } from "../../libs/queryClient";
import { SearchDate } from "./SearchDate";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface City {
  id: number;
  nome: string;
  estado: string;
}

function debouncePromise<T extends (...args: any[]) => Promise<any>>(
  func: T,
  wait: number
): T {
  let timeout: ReturnType<typeof setTimeout>;

  return ((...args: Parameters<T>) => {
    clearTimeout(timeout);

    return new Promise((resolve) => {
      timeout = setTimeout(() => {
        resolve(func(...args));
      }, wait);
    });
  }) as T;
}


export function Search() {
  const { control, register, setValue, watch, getValues } = useFormContext();

  const data_saida = watch("data_saida");

  console.log(data_saida)

  useEffect(() => {
    setValue("dia_semana", diaDaSemana(new Date()));
    setValue("data_saida", new Date());
  }, []);

  useEffect(() => {
    setValue("dia_semana", diaDaSemana(data_saida));
  }, [data_saida, setValue]);

  async function getCity(input: string): Promise<{ value: number; label: string }[]> {
    if (!input) {
      return [];
    }
  
    const res: City[] = await api
      .get("cidades", { params: { nome: input } })
      .then((result) => result.data.data);
  
    return res.map((item) => ({ value: item.id, label: `${item.nome}` }));
  }
  
  const debouncedGetCity = debouncePromise(getCity, 1000);

  async function onSearch() {
    queryClient.removeQueries({queryKey: ['passagens'], exact: false })

    const values = getValues();

    console.log(values)

    setValue("search", {
      origem: values?.origem.value,
      destino: values?.destino.value,
      data: format(new Date(values?.data_saida ?? ''), "yyyy-MM-dd", {locale: ptBR}),
    });
  }

  return (
    <Box
      display={"flex"}
      width={"100%"}
      px={2}
      bg={"white"}
      justifyContent={"start"}
      alignItems={"center"}
    >
      <Flex width={{
        xs: 'full',
        lg: '100%',
        xl: '60vw',
        '2xl': '60vw',
      }} alignItems={{
        xs: 'center',
        lg: 'end',
      }} p={2} flexDir={{
        xs: 'column',
        lg: 'row',
      }}>
        <FormControl>
          <FormLabel mb={0}>Origem</FormLabel>
          <Controller
            name="origem"
            control={control}
            render={({ field: { onChange, onBlur, ref, value, name } }) => (
              <AsyncSelect
                cacheOptions
                onMenuOpen={() => onChange(null)}
                defaultOptions={[]}
                loadOptions={debouncedGetCity}
                onChange={(e) => onChange(e)}
                onBlur={onBlur}
                value={value || null}
                name={name}
                ref={ref}
                className="react-select-container"
                noOptionsMessage={() => "Não há resultados"}
                placeholder="Cidade - UF"
                styles={optionsSelectStyles}
                loadingMessage={() => "Buscando..."}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <FormLabel mb={0}>Destino</FormLabel>
          <Controller
            name="destino"
            control={control}
            render={({ field: { onChange, onBlur, ref, value, name } }) => (
              <AsyncSelect
                cacheOptions
                onMenuOpen={() => onChange(null)}
                defaultOptions={[]}
                loadOptions={debouncedGetCity}
                onChange={(e) => onChange(e)}
                onBlur={onBlur}
                value={value || null}
                name={name}
                ref={ref}
                placeholder="Cidade - UF"
                noOptionsMessage={() => "Não há resultados"}
                loadingMessage={() => "Buscando..."}
                styles={optionsSelectStyles}
              />
            )}
          />
        </FormControl>
        <SearchDate />
        <ChakraInput
          borderRadius={'none'}
          focusBorderColor="purple.900"
          bgColor="white"
          variant="filled"
          borderColor={'black'}
          color={"#000"}
          borderWidth={'1px'}
          borderStyle="solid"
          size={'lg'}
          height={'2rem'}
          minHeight={'2rem'}
          _hover={{
            backgroundColor: 'white',
            borderColor: 'black',
          }}
          {...register("dia_semana")}
          maxWidth={{
            xs: 'full',
            lg: '15%'
          }}
          textAlign={"center"}
        />
        <Button
          px={'1rem'}
          py={'2rem'}
          borderBottom={"2px solid #385f20"}
          onClick={onSearch}
          fontWeight={'600'}
          fontSize={'16px'}
          lineHeight={'normal'}
          borderRadius={'5px'}
          bg={"#4caf50"}
          textTransform={'uppercase'}
          color={"white"}
          maxWidth={'160px'}
          width={"full"}
          ml={2}
          _hover={{
            backgroundColor: '#385f20'
          }}
        >
          Consultar
        </Button>
      </Flex>
    </Box>
  );
}
